import Tool from '../../../tools/Tool';
import tools from '../../../tools';

class ToolTableOptions extends Tool {
  static toolName = 'Table options';
  static iconClass = 'fa-regular fa-ellipsis';

  static submenuTools = () => [
    [tools.ToolTableHeaderRow, tools.ToolTableHeaderColumn],
    [tools.ToolTableAlternateRowToggle],
    [tools.ToolTableFullWidth, tools.ToolResetColumnWidths],
    [tools.ToolDeleteTable],
  ];

  static submenuType = 'list-toggles' as const;
}

export default ToolTableOptions;
